import {
  BackendResponseModel,
  ErrorCodes,
  RawHttpErrorResponse,
} from '../../models';
import { BaseErrorHandler } from './base-error.handler';

export class UnknownErrorHandler extends BaseErrorHandler {
  handle(): BackendResponseModel {
    const result = new BackendResponseModel();

    if (this.httpResponseError instanceof RawHttpErrorResponse) {
      this.httpResponseError.errors.forEach((error) =>
        result.addError({
          errorCode: error.errorCode,
          errorDescription: error.message,
          errorDetails: error.details,
          memberName: '',
        })
      );
    } else {
      result.addError({
        errorCode: ErrorCodes.Unknown,
        errorDescription: JSON.stringify(this.httpResponseError),
        errorDetails: '',
        memberName: '',
      });
    }
    return result;
  }

  canHandle(): boolean {
    return true;
  }
}
